import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/_services/user.service';

@Component({
    templateUrl: 'userRegister.component.html',
    styleUrls: ['./userRegister.component.css']
})
export class UserRegisterComponent implements OnInit {


    captchaError: boolean = false;
    capResponse : String="";
    @ViewChild('recaptcha', {static: true }) recaptchaElement: ElementRef;
    registerForm: UntypedFormGroup;

    submitted = false;
    constructor(
        private formBuilder: UntypedFormBuilder,
        private router: Router,
        private userService: UserService,
        private toastr: ToastrService,
    ) {
    }
    ngOnInit() {
         this.addRecaptchaScript();

        this.registerForm = this.formBuilder.group({
            name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required],
            companyName: ['', [Validators.required]],
            // Industry: ['', [Validators.required]],
            // Role: ['', [Validators.required]]

        });
    }
    get f() { return this.registerForm.controls; }

    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.registerForm.invalid) {
            return;
        }
         if ( this.capResponse===''){
            this.captchaError = true;
            return;
         }else{
            this.captchaError = false;
         }
  // var userRegisterObj={
  //   name:this.registerForm.value.name,
  //   email:this.registerForm.value.email.toLowerCase(),
  //   password:this.registerForm.value.password,
  //   companyName:this.registerForm.value.email,
  // }
        this.userService.register(this.registerForm.value, this.capResponse);
        if (window['grecaptcha']){
            window['grecaptcha'].reset();
        }
    }

    addRecaptchaScript() {
 
        window['grecaptchaCallback'] = () => {
          this.renderReCaptcha();
        }
       
        (function(d, s, id, obj){
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) { obj.renderReCaptcha(); return;}
          js = d.createElement(s); js.id = id;
          js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
          fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'recaptcha-jssdk', this));
       
      }

      renderReCaptcha() {
        window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
          'sitekey' : '6LeHQe0oAAAAAGSg-m5oirxSCTny4umGcWOWTj40',
          'callback': (response) => {
            //  //console.log(response);
              this.capResponse = response;
          }
        });
      }
}
